export default __webpack_public_path__ + "static/media/factory__49.116d4634.jpg";